/**
 * Memorial Day bundle cards — subscription add + welcome gifts + cart drawer.
 */
(function () {
  if (window.__rncMemCartInit) return;
  window.__rncMemCartInit = true;

  function copyPromoButtons() {
    document.querySelectorAll('[data-mem-promo-code]').forEach(function (btn) {
      if (btn.dataset.memCopyBound) return;
      btn.dataset.memCopyBound = '1';
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-mem-promo-code') || '';
        function ok() {
          btn.classList.add('rnc-mem-promo--copied');
          var h = btn.querySelector('.rnc-mem-promo__copy-hint, .rnc-mem-banner__code-hint');
          if (h) h.textContent = 'Copied';
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(ok).catch(function () {});
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mem-bundle-atc]');
    if (!btn) return;
    e.preventDefault();

    var card = btn.closest('.rnc-mem-bundle-card');
    if (!card) return;

    var variantId = parseInt(card.getAttribute('data-variant-id'), 10);
    var sellingPlanId = card.getAttribute('data-selling-plan-id');
    var handle = card.getAttribute('data-handle') || '';
    var api = window.RNC_BUNDLE_GIFTS;

    if (!variantId) {
      window.location.href = '/products/' + handle;
      return;
    }

    if (!api || typeof api.addBundleToCart !== 'function') {
      console.warn('RNC_BUNDLE_GIFTS not loaded');
      return;
    }

    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    api
      .addBundleToCart({
        variantId: variantId,
        sellingPlanId: sellingPlanId,
        bundleHandle: handle,
        isSubscribe: true,
        openDrawer: true,
      })
      .then(function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'mem_day_cta_click',
            placement: 'bundle-atc',
            product_handle: handle,
          });
        } catch (err) {}
        btn.textContent = 'Added →';
        setTimeout(function () {
          btn.textContent = orig;
          btn.disabled = false;
        }, 2500);
      })
      .catch(function (err) {
        var msg = (err && err.message) || '';
        if (/sold out|unavailable|not available/i.test(msg)) {
          btn.textContent = 'Sold out — view product';
          btn.disabled = false;
          setTimeout(function () {
            window.location.href = '/products/' + handle;
          }, 1200);
          return;
        }
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = orig;
        }, 2000);
      });
  });

  document.querySelectorAll('[data-mem-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mem_day_cta_click',
          placement: el.getAttribute('data-mem-cta'),
        });
      } catch (e) {}
    });
  });

  copyPromoButtons();
})();
